import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '$store';
import { LockedIcon } from '~components/icons/LockedIcon';
import { UnlockedIcon } from '~components/icons/UnlockedIcon';
import useAppDispatch from '~hooks/useAppDispatch';
import {
  processNextAsset,
  resetSelectedFields,
  toggleSelectedFieldThunk,
} from '~modules/media-library/controller/thunks/contribute';

const SelectFieldsForm = () => {
  const data = useSelector((store: RootState | any) => store.contribute);
  const consentsData = useSelector((store: RootState) => store.assetRelations);

  const { contributionDataLoading, contributionDraftSchema, selectedFields, contributionDraftData } = data;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetSelectedFields());
  }, [dispatch]);

  const handleCheckboxChange = (fieldName: string) => {
    dispatch(toggleSelectedFieldThunk(fieldName));
  };

  const renderFieldValue = (fieldName: string, fieldValue: any) => {
    const fieldSchema = contributionDraftSchema.properties[fieldName];
    if (fieldSchema && fieldSchema.enum && fieldSchema.enum_titles) {
      const index = fieldSchema.enum.indexOf(fieldValue);
      return index !== -1 ? fieldSchema.enum_titles[index] : fieldValue;
    }

    // Handle array values
    if (Array.isArray(fieldValue)) {
      return fieldValue.join(', ');
    }
    return fieldValue;
  };

  const toReadableFormat = (fieldName: string): string => {
    return fieldName.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
  };

  const renderCheckbox = (fieldName: string, fieldValue: any) => {
    if (fieldValue === '' || fieldValue === null) {
      return null;
    }

    return (
      <div
        onClick={() => handleCheckboxChange(fieldName)}
        key={fieldName}
        className="mb-2 relative flex cursor-pointer rounded-lg px-2 py-4 shadow-md focus:outline-none m-2 w-full"
      >
        <label className="flex items-center w-full">
          <input
            type="checkbox"
            checked={fieldName in selectedFields}
            onChange={() => handleCheckboxChange(fieldName)}
            style={{ opacity: 0 }}
          />
          <span className={`font-medium ${fieldName in selectedFields ? 'text-gray-700' : 'text-gray-900'}`}>
            {toReadableFormat(fieldName)} : {renderFieldValue(fieldName, fieldValue)}
          </span>
        </label>
        <div style={{ right: '20px' }} className="absolute">
          {fieldName in selectedFields ? <LockedIcon className="h-6 w-6" /> : <UnlockedIcon className="h-6 w-6" />}
        </div>
      </div>
    );
  };

  return (
    <form className="p-3 bg-indigo-600 ">
      <h3 className="mb-4">What input would you like to keep?</h3>
      {!contributionDataLoading &&
        Object.entries(contributionDraftData).map(([fieldName, fieldValue]) => renderCheckbox(fieldName, fieldValue))}
      {consentsData.relevantDocuments &&
        renderCheckbox('relevantDocuments', consentsData.relevantDocuments.map(file => file.name).join(', '))}
      <div className="flex my-4 justify-center">
        <button
          type="button"
          className="h-10 button c-button c-button--light u-padding-horizontal-lg mx-2 mt-4"
          onClick={() => dispatch(processNextAsset())}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default SelectFieldsForm;
